import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const AppointmentVolumeMetrics = ({ dateRange, provider }) => {
  const volumeData = [
    { date: 'Mon', scheduled: 45, completed: 42, noShow: 3 },
    { date: 'Tue', scheduled: 52, completed: 48, noShow: 4 },
    { date: 'Wed', scheduled: 48, completed: 46, noShow: 2 },
    { date: 'Thu', scheduled: 55, completed: 51, noShow: 4 },
    { date: 'Fri', scheduled: 50, completed: 47, noShow: 3 },
    { date: 'Sat', scheduled: 30, completed: 28, noShow: 2 },
    { date: 'Sun', scheduled: 15, completed: 14, noShow: 1 }
  ];

  const metrics = [
    {
      label: 'Total Appointments',
      value: '295',
      change: '+12%',
      trend: 'up',
      icon: 'Calendar'
    },
    {
      label: 'Completion Rate',
      value: '92.5%',
      change: '+2.3%',
      trend: 'up',
      icon: 'CheckCircle'
    },
    {
      label: 'No-Show Rate',
      value: '6.4%',
      change: '-1.2%',
      trend: 'down',
      icon: 'XCircle'
    },
    {
      label: 'Provider Utilization',
      value: '87%',
      change: '+5%',
      trend: 'up',
      icon: 'Users'
    }
  ];

  return (
    <div className="bg-card rounded-xl border border-border shadow-elevation-2 p-4 md:p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg md:text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="Calendar" size={20} className="text-primary" />
          Appointment Volume
        </h2>
        <span className="text-xs text-muted-foreground">
          {dateRange === 'day' ? 'Today' : dateRange === 'week' ? 'This Week' : dateRange === 'month' ? 'This Month' : dateRange === 'quarter' ? 'This Quarter' : 'This Year'}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-6">
        {metrics?.map((metric, index) => (
          <div key={index} className="bg-muted/50 rounded-lg p-3 border border-border">
            <div className="flex items-center gap-2 mb-2">
              <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/10 text-primary">
                <Icon name={metric?.icon} size={16} />
              </div>
              <div className="flex items-center gap-1">
                <Icon
                  name={metric?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'}
                  size={14}
                  className={metric?.trend === 'up' ? 'text-success' : 'text-destructive'}
                />
                <span className={`text-xs font-semibold ${
                  metric?.trend === 'up' ? 'text-success' : 'text-destructive'
                }`}>
                  {metric?.change}
                </span>
              </div>
            </div>
            <p className="text-xs text-muted-foreground mb-1">{metric?.label}</p>
            <p className="text-xl font-bold text-foreground">{metric?.value}</p>
          </div>
        ))}
      </div>

      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={volumeData} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis
              dataKey="date"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '8px',
                color: 'var(--color-foreground)'
              }}
            />
            <Line
              type="monotone"
              dataKey="scheduled"
              stroke="#2563EB"
              strokeWidth={2}
              dot={{ r: 3 }}
              name="Scheduled"
            />
            <Line
              type="monotone"
              dataKey="completed"
              stroke="#059669"
              strokeWidth={2}
              dot={{ r: 3 }}
              name="Completed"
            />
            <Line
              type="monotone"
              dataKey="noShow"
              stroke="#DC2626"
              strokeWidth={2}
              dot={{ r: 3 }}
              name="No-Show"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AppointmentVolumeMetrics;